<script setup lang="ts">
import { Ref } from "vue/dist/vue";

interface ICheckbox {
	modelValue: boolean;
	id?: string;
	error?: string | null | undefined | Ref<string>;
	label: string;
	size?: "small" | "medium" | "large";
}

const props = withDefaults(defineProps<ICheckbox>(), {
	modelValue: false,
	error: null,
	id: "",
	size: "large",
});

const emit = defineEmits(["update:modelValue"]);

const value = computed({
	get() {
		return props.modelValue;
	},
	set(val) {
		emit("update:modelValue", val);
	},
});

const checkboxID = generatedID(props.label, props.id);

const sizeClass = {
	span: {
		small: tw`w-[26px] h-[16px] after:w-[9px] after:h-[9px]`,
		medium: tw`w-[40px] h-[22px] after:w-[16px] after:h-[16px]`,
		large: tw`w-[52px] h-[32px] after:w-[22px] after:h-[22px]`,
	},
	label: {
		small: tw`text-xs`,
		medium: tw`text-sm`,
		large: tw``,
	}
};
</script>

<template>
	<label class="relative inline-flex items-center cursor-pointer toggle-wrapper gap-2" :class="sizeClass.label[props.size]">
		<input :id="checkboxID" type="checkbox" class="sr-only" v-model="value" />
		<span :class="sizeClass.span[props.size]"></span>
		{{ label }}
	</label>
</template>

<style scoped lang="scss">
.toggle-wrapper {
	input {
		&:focus {
			~ span {
				@apply ring-0;
			}
		}
		&:checked {
			~ span {
				@apply ring-0 bg-identity;
				&:after {
					@apply translate-x-full border-light-50 bg-light-50;
				}
			}
		}
		&:not(:checked) {
			~ span {
				@apply border-2 border-dark-600 dark:border-light-400 bg-light-50 dark:bg-dark-700;
				&:after {
					@apply bg-dark-600 dark:bg-light-50 scale-[85%];
				}
			}
		}
	}
	span {
		@apply bg-dark-200 rounded-full;
		&:after {
			@apply absolute top-1/2 -translate-y-1/2 border-2 border-dark-600 transition-all duration-300 rounded-full left-1;
			content: " ";
		}
	}
}
</style>
